import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Page } from '../../layout/AppLayout.jsx'
import Tabs from '../../components/ui/Tabs.jsx'
import { useCompany } from '../../context/CompanyContext.jsx'
import CompanyTab from './CompanyTab.jsx'
import ProfileTab from './ProfileTab.jsx'
import BillingTab from './BillingTab.jsx'
import SubscriptionTab from './SubscriptionTab.jsx'
import UsersTab from './UsersTab.jsx'
import ArchivesTab from './ArchivesTab.jsx'
import AuditTab from '../admin/AuditTab.jsx'

/*
 * Profil & société — inventory §5. Tabbed hub: company profile/logo, my
 * profile/password, billing (bank accounts + numbering), and (admin) user
 * management. Active tab mirrored to ?tab= so links/refreshes stay put.
 */
export default function SettingsPage() {
  const { t } = useTranslation()
  const { isAdmin, currentCompanyId } = useCompany()
  const [params, setParams] = useSearchParams()

  const tabs = [
    { key: 'company', icon: 'building', label: t('settings.tabs.company'), el: <CompanyTab /> },
    { key: 'profile', icon: 'customers', label: t('settings.tabs.profile'), el: <ProfileTab /> },
    { key: 'billing', icon: 'credit-card', label: t('settings.tabs.billing'), el: <BillingTab /> },
    { key: 'subscription', icon: 'invoice', label: t('settings.tabs.subscription'), el: <SubscriptionTab /> },
    { key: 'archives', icon: 'download', label: t('settings.tabs.archives'), el: <ArchivesTab /> },
    ...(isAdmin() ? [
      { key: 'users', icon: 'shield', label: t('settings.tabs.users'), el: <UsersTab /> },
      { key: 'audit', icon: 'eye', label: t('settings.tabs.audit'), el: <AuditTab endpoint={`/companies/${currentCompanyId}/audit`} /> },
    ] : []),
  ]
  const active = tabs.some((tb) => tb.key === params.get('tab')) ? params.get('tab') : 'company'
  const current = tabs.find((tb) => tb.key === active)

  return (
    <Page title={t('settings.title')}>
      <Tabs tabs={tabs} active={active} onChange={(k) => setParams({ tab: k }, { replace: true })} />
      {current?.el}
    </Page>
  )
}
